import { html, LitElement, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../ui-inlined-svg/ui-inlined-svg';
import iconStyle from './ui-no-search-result-icon.css?inline';

const CName = 'ui-no-search-result-icon';

@customElement(CName)
export class UINoSearchResultIcon extends LitElement {
  static readonly styles = unsafeCSS(iconStyle);

  render() {
    // Use vite to transform static URL
    const assetUrl = new URL('/assets/ui-core/icons/no-search-result-icon.svg', import.meta.url).href;
    return html`<ui-inlined-svg .defer=${true} .src=${assetUrl}></ui-inlined-svg>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UINoSearchResultIcon;
  }
}
